import { Component } from '@angular/core';
import { Nav, NavController, NavParams, AlertController } from 'ionic-angular';
import { HomePage } from '../home/home';
import { SlideContentPage } from '../slidecontent/slidecontent';
import { PortfoliosPage } from '../portfolios/portfolios';
import { CartPage } from '../cart/cart';
import { HttpClient } from '@angular/common/http';
import { AppConfigProvider } from '../../providers/app-config/app-config';

@Component({
  selector: 'page-menu',
  templateUrl: 'menu.html'
})
export class MenuPage {
  pages: Array<{ title: string; component: any }>;
  subportfolios: Array<{ title: string; img: string }>;
  contents: Array<{ title: string; attachments: string[] }>;
  portfolio_title: string;
  portfolio_id: string;
  header_img: string;

  constructor(
    public navCtrl: NavController,
    public nav: Nav,
    public navParams: NavParams,
    private http: HttpClient,
    private appConfig: AppConfigProvider,
    private alertCtrl: AlertController
  ) {
    this.portfolio_title = navParams.get('portfolio_title');

    this.portfolio_id = navParams.get('portfolio_id');
    this.header_img = navParams.get('header_img');

    this.pages = [
      { title: 'Home', component: HomePage },
      { title: 'Portfolios', component: PortfoliosPage },
      { title: 'Cart', component: CartPage }
    ];
    this.subportfolios = [];
    this.contents = [];

    this.getSubportfolio(this.portfolio_id);

    // console.log(this.subportfolios);
  }

  openPage(page) {
    this.navCtrl.push(page.component);
  }

  openSlide(row) {
    if ( row.title.toLowerCase().indexOf('upcoming') != -1 ) {
      let alert = this.alertCtrl.create({
        title: 'Item Coming Soon',
        subTitle: 'Sorry, item will not be available until release.',
        buttons: ['Dismiss']
      });

      alert.present();
    } else {
      this.navCtrl.push(SlideContentPage, {
        subportfolio_id: row.id,
        img: row.img,
        price: row.price,
        title: row.title
      });
    }
  }

  goToCart() {
    this.navCtrl.push(CartPage);
  }

  getSubportfolio(portfolio_id) {
    this.http
      .post(this.appConfig.apiUrl() + 'index.php/api/subportfolio/list', {
        token: 'token',
        portfolio_id: this.portfolio_id,
        app_key: this.appConfig.appKey()
      })
      .subscribe(
        (res: any) => {
          // console.log('success');
          console.log(res);

          if (res.subportfolio) {
            let data = res.subportfolio;
            for (let sub of data) {
              let temp = {
                id: sub.id,
                title: sub.title,
                img: sub.feature_image,
                price: sub.price,
                contentCount: sub.total_contents
              };
              this.subportfolios.push(temp);
            }
          }
        },
        err => {
          console.log('error');
        }
      );
  }

  getContents() {
    this.http
      .post(this.appConfig.apiUrl() + 'index.php/api/content/list', {
        token: 'token',
        portfolio_id: 1,
        app_key: this.appConfig.appKey()
      })
      .subscribe(
        (res: any) => {
          // console.log('success ');
          // console.log(res);

          if (res) {
            let data = res;
            for (let content of data) {
              let temp = {
                title: content.title,
                attachments: content.attachments
              };
              this.contents.push(temp);
            }
          }
        },
        err => {
          console.log('error');
        }
      );
  }

  checkComingSoon() {
    var sentence = "Check this answer and you can find the keyword with this code";
    var search  = "keyword";

    if ( sentence.toLowerCase().indexOf(search.toLowerCase()) != -1 ) {

      return true;
    } else {

      return false;

    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/menu/menu.ts